import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_con6gck7: FaireBrandEntity = {
  token: "b_con6gck7",
  type: "brand",
  name: "Ali+Oli",
  avatarUrl:
    "https://cdn.faire.com/fastly/d8ebe5976fff9d544b55ed856d496499de64816cb86810105e0270a9073dd6b4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bd0dad787250c3e62a98b259ef5b0760d6e94278f3289cf6325065c40000185d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d8ebe5976fff9d544b55ed856d496499de64816cb86810105e0270a9073dd6b4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bd0dad787250c3e62a98b259ef5b0760d6e94278f3289cf6325065c40000185d.jpeg",
  location: "Miami, FL, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 371,
  isTopShop: true,
  isInsider: true,
  description:
    "If you need more quantities than what is available, please send us a message. We have professional hero and lifestyle images that we share with you once you place your first order. Most all of our products are CPSIA tested and approved, and we also carry product liability insurance.  All of our products have beautiful & minimalistic packaging. We select the shipping carrier based on the cheapest rate available. We respond to your messages usually within a few hours and provide excellent customer service. We have been working in the baby retail industry since 2007. We reuse shipping boxes when possible. \n\nOur products are created with your customer in mind.  They're fun, fashionable, and most importantly, practical.  They're the perfect fit for your boutique and for your discerning customers who demand high-quality products for their children. No detail goes unnoticed, which is why you can purchase with confidence today.\n\nAs a mother and a business owner, what makes me incredibly proud of the work I do is the fact that I am able to provide high-quality and stylish baby products to other mothers. I remember how enjoyable it was to select the perfect baby products for my own daughters, and how crucial it was for them to be both functional and aesthetically pleasing. Knowing that other moms trust our brand and choose our Ali+Oli baby products is a truly rewarding feeling. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:33.644Z",
    importedBy: "entity-db-cli",
  },
};
